module.exports = __webpack_public_path__ + "static/img/ewm_ios.3cf5baf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/byl/footer/images/ewm_ios.png
// module id = ldf9
// module chunks = 1